import { render, staticRenderFns } from "./OBListingWithEarmarkedRelievers.vue?vue&type=template&id=24f7c01a&scoped=true&"
import script from "./OBListingWithEarmarkedRelievers.vue?vue&type=script&lang=js&"
export * from "./OBListingWithEarmarkedRelievers.vue?vue&type=script&lang=js&"
import style0 from "./OBListingWithEarmarkedRelievers.vue?vue&type=style&index=0&id=24f7c01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7c01a",
  null
  
)

export default component.exports